var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',[_c('span',{staticClass:"cx_badge badge badge-pill",class:_vm.variant},[_vm._v(_vm._s(_vm.$api.formatter.formatByList(_vm.value, _vm.list)))])])}
var staticRenderFns = []

export { render, staticRenderFns }